import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import {
  createLessonsAPIEndpoint,
  EndPoints,
} from "../../../../services/LessonAPI";

const LessonStatusToggle = ({
  lesson,
  fetchLessons,
  page,
  pageSize,
  search,
}) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    createLessonsAPIEndpoint(EndPoints.toggleLessonStatus)
      .putById(lesson.id, {})
      .then(() => {
        fetchLessons(page, pageSize, search);
        setOpen(false);
      })
      .catch((error) => {
        console.error("Error updating Lesson status:", error);
        setOpen(false);
      });
  };

  const confirmMessage = lesson.isActive
    ? "Are you sure you want to deactivate this Lesson?"
    : "Are you sure you want to activate this Lesson?";

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className={`btn-toggle-status ${
          lesson.isActive ? "deactivate" : "activate"
        }`}
      >
        {lesson.isActive ? "Deactivate" : "Activate"}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="confirm-dialog">
          <DialogTitle className="confirm-dialog-title">
            Confirm Action
          </DialogTitle>

          <p className="confirm-dialog-message">{confirmMessage}</p>
          <DialogContent className="confirm-dialog-actions">
            <Button
              variant="outline"
              onClick={() => setOpen(false)}
              className="cancel-button"
            >
              Cancel
            </Button>
            <Button
              className={lesson.isActive ? "deactivate" : "activate"}
              onClick={handleConfirm}
            >
              Yes, {lesson.isActive ? "Deactivate" : "Activate"}
            </Button>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LessonStatusToggle;
